(function($) {

    $(document).ready(function() {
        $('.filter-list').change(function(e) {

            var optionSelected = $(this).find("option:selected");
            var category = optionSelected.data('category');

            if (category == 'all') {
                window.location = '/blog';
            } else {
                window.location = '/blog?category=' + category;
            }
        });
    }); 

})(jQuery);

// copy link to clipboard
// var btn = document.getElementById("copyLinkClipboard");
// var btn2 = document.getElementById("copyLinkClipboard2");
// btn.addEventListener("click", copyLinkClipboard);
// btn2.addEventListener("click", copyLinkClipboard);

// function copyLinkClipboard() {
//   var text = window.location.href;
//   var elem = document.createElement("textarea");
//   document.body.appendChild(elem);
//   elem.value = text;
//   elem.select();
//   document.execCommand("copy");
//   document.body.removeChild(elem);
//   alert("Blog Link Copied");
// }

jQuery('#copyLinkClipboard, #copyLinkClipboard2').click(function (){
    var text = window.location.href;
    var elem = document.createElement("textarea");
    document.body.appendChild(elem);
    elem.value = text;
    elem.select();
    document.execCommand("copy");
    document.body.removeChild(elem);
    alert("Blog Link Copied");
});
